import { ApiModule } from '@common/index';
import type { PostGraduateEducationElement } from '../models';

export class PostGraduateEducationElementApi extends ApiModule {
  protected endpoint = '/post-graduate-education-element';

  public loadPostGraduateEducationElementDetails(id: number) {
    return this.api.get<PostGraduateEducationElement>(`${this.endpoint}?id=${id}`);
  }

  public savePostGraduateEducationElement(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePostGraduateEducationElement(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public getList(educationId: number) {
    return this.api.get<PostGraduateEducationElement[]>(`${this.endpoint}/list-education?educationId=${educationId}`);
  }
}
